import React from 'react';
import { useTranslation } from 'react-i18next';

import { BUSINESS_TOOL_MODE } from 'constants/businessTool';
import { useBusinessToolSessionStore } from 'store/useBusinessToolStore';
import { getBusinessToolMode, getSetBusinessToolMode } from 'store/useBusinessToolStore/selectors';

import { checkIsPreviewMode } from 'pages/BusinessToolPage/utils';

import { useIsBusinessPlanOwner } from 'hooks/useIsBusinessPlanOwner';

import { TextSwitcher } from 'components/_basic/TextSwitcher';

import { useAIActionHandler } from '../BusinessToolAiProvider/hooks/useAIActionHandler';

export const ModeSwitch: React.FC = () => {
  const { t } = useTranslation();
  const isBusinessPlanOwner = useIsBusinessPlanOwner();

  const { handleActionWithAICheck } = useAIActionHandler();

  const businessToolMode = useBusinessToolSessionStore(getBusinessToolMode);
  const setBusinessToolMode = useBusinessToolSessionStore(getSetBusinessToolMode);

  const handleSetEditMode = (previewMode: boolean) => {
    handleActionWithAICheck(() =>
      setBusinessToolMode(previewMode ? BUSINESS_TOOL_MODE.PREVIEW : BUSINESS_TOOL_MODE.EDIT),
    );
  };

  const isPreviewMode = isBusinessPlanOwner ? checkIsPreviewMode(businessToolMode) : true;

  return (
    <TextSwitcher
      firstOption={t(isBusinessPlanOwner ? 'edit' : 'preview')}
      secondOption={isBusinessPlanOwner ? t('preview') : undefined}
      isSwitcherOn={isPreviewMode}
      setSwitcherOn={isBusinessPlanOwner ? handleSetEditMode : undefined}
    />
  );
};
